import { EUserType, Sdk, SdkFactory } from "@dreamcam/messenger-sdk";

import { TUserAuthData } from "@storage/session/types";
import { appTokenStorage, userAuthDataStorage } from "@storage/sessionStorage";

import { DELAY_TIME_5000 } from "@configs/constants";
import { ENV_CONFIG } from "@configs/env";

let sdk: Sdk;

export const sdkMessenger = () => {
	if (sdk) return sdk;
	sdk = SdkFactory.createInstance({
		baseUrl: ENV_CONFIG.BASE_MESSENGER_URL_SERVER || "",
		baseWsUrl: ENV_CONFIG.BASE_MESSENGER_URL_WS || "",
		pingIntervalInMillis: DELAY_TIME_5000,
		options: {
			isChatsSort: true,
		},
		onUnauthorizedRequestAsync: async () => {
			const userData = userAuthDataStorage.getItemAsJson<TUserAuthData>();
			const app_token = appTokenStorage.getItem();

			return {
				user_id: userData?.userId || "",
				chat_client_id: userData?.chatClientId || "",
				user_type: EUserType.MODEL,
				bss_session_id: app_token || "",
			};
		},
	});

	return sdk;
};
